// Added fakeLocalStorage to be able to load the site on private Safari
import '../store/fakeLocalStorage.js';

// BANJO-5522
self.history.scrollRestoration = 'manual';

function loadScript(src) {
	return new Promise((resolve, reject) => {
		const script = document.createElement('script');
		script.src = src;
		script.onload = resolve;
		script.onerror = reject;
		document.head.appendChild(script);
	});
}
function loadStyle(src) {
	return new Promise((resolve, reject) => {
		const link = document.createElement('link');
		link.src = src;
		link.onload = resolve;
		link.onerror = reject;
		document.head.appendChild(link);
	});
}
export { loadScript, loadStyle };
